define(function() {
  const IpsModel = require('civicsBase/ipsModel');

  return IpsModel.extend({
    urlRoot: '/delegate/civics-api/api/gis/sync/keyfields',
    url: function() {
      var url = this.urlRoot;

      if (this.syncType == 'syncMoniker') {
        url += '?moniker=' + this.syncValue;
      } else if (this.syncType == 'syncMapping') {
        url += '?syncmappingname=' + this.syncValue;
      }

      return url;
    },
  });
});
